import type { FaireProductEntity } from "../../entity_types/product";

export const p_jh55kwxbbu: FaireProductEntity = {
  token: "p_jh55kwxbbu",
  type: "product",
  name: "Witch Hazel (Alcohol Free)",
  brandToken: "b_m9m8u7ancn",
  brandName: "HalalEveryDay",
  imageUrl:
    "https://cdn.faire.com/fastly/3e46b6a1c796527bba8b2e9cbcc87f7ad0f3d7c6498a256ddf6b85fb7302fd7f.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4462833010226471f74bbd65d91bb19d9d23e31a00484cd76807576521993ae7.webp",
    "https://cdn.faire.com/fastly/df2f9d0565c3335e4c1fd7912fb3583da245e2a3e739ef1ff43e0498a8e8c118.webp",
    "https://cdn.faire.com/fastly/e2640e540a2ba4f9e65f993f70062acf69d671fff0c3b8be1bffc7bbbed91264.webp",
    "https://cdn.faire.com/fastly/424e310c3f28f94f56d351919f7732d030728049fce6d5280a17ad1ecac66d67.webp",
    "https://cdn.faire.com/fastly/602cff656125da35d3a9f66d8fb17cb1e1af0e85300a02b88962b0799b1e119c.webp",
  ],
  priceDollars: 3.97,
  description:
    "\nWitch Hazel\n\n * Alcohol Free \n * 100% Pure | Natural \n * Botanical Name: Hamamelis Virginiana. \n * Grade: Alcohol Free. \n * Extraction By: Distillation. \n * Parts Used: Twigs and Bark. \n * Appearance: Colorless Liquid with characteristic odor. \n * Premium Quality | Grade A \n * Bulk / Wholesale Size Available. \n * Witch Hazel, also called Winterbloom, is a small shrub native to North America and has long been part of traditional medicine and a popular topical home remedy for various skin ailments. Today the extracts made from the plant continue to be used for their cleansing, toning, and nourishing properties. It contains tannins, kaempferol, quercetin, polyphenols, saponins and some volatiles like eugenol and gallic acid as active compounds.",
  tags: [],
  msrpDollars: 7.95,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:54.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
